import { uniqueKey } from 'global/common/keys'
import { gEnums } from 'global/enums/globalEnums'
import ListAdd from 'global/lists/ListAdd'
import SemFileViewer from '../sem/SemFileViewer'
import AppUserDataPermissions from './elements/AppUserDataPermissions'
import { ColorPicker } from './elements/ColorPicker'
import MenuItemsSelect from './elements/MenuItemsSelect'
import NumberPicker from './elements/NumberPicker'
import ThemedColors from './elements/ThemedColors'
import ItemMap from './groupedElements/ItemMap'
import DataConstraintList from './elements/DataConstraintList'
import { useDynamicListOptions } from 'global/cnr/contexts/useHelpers/optionsBuilder/useDynamicListOptions'
import NumberPadPicker from './elements/NumberPadPicker'
import PhoneNumberInput from './elements/PhoneNumberInput'
import TableMap from './elements/TableMap'
import DateInput from './elements/DateInput'
import { useContext } from 'react'
import { SquaresContext } from 'global/wrappers/SquaresWrapper'

export const FormItemsAlt = ({
  _key,
  fip,
  formItemType,
  formKey,
  handleChange,
  item,
  itemProp,
  localData,
  prop,
  view,
}) => {

  const squaresContext = useContext(SquaresContext)
  const { squares_state } = squaresContext ?? {}

  const { getDynOption } = useDynamicListOptions()

  switch (formItemType) {
    case gEnums.formItemTypes.appUserDataModificationList:
      return <AppUserDataPermissions />

    case gEnums.formItemTypes.fileSelect:
      return <div style={{ border: '1px solid var(--off-black-5)', padding: '10px' }}>File Select: TBD</div>
    // return <SemFileViewer fileMode={gEnums.fileModes.viewWithSelect} noMid={true} />

    case gEnums.formItemTypes.fileItemSelect:
    case gEnums.formItemTypes.fileItemSelectDirect:
      return <SemFileViewer fileMode={gEnums.fileModes.viewWithSelectDirect} noMid={true} />

    case gEnums.formItemTypes.fileManifestSelect:
      return <SemFileViewer fileMode={gEnums.fileModes.viewManifest} noMid={true} />

    case gEnums.formItemTypes.fileSelect:
      return <div style={{ border: '1px solid var(--off-black-5)', padding: '10px' }}>File Select: TBD</div>
    // return <SemFileViewer fileMode={gEnums.fileModes.viewWithSelect} noMid={true} />
    // return <SemFileViewer fip={fip} fieldProps={fieldProps} formProps={formProps} fileMode={gEnums.fileModes.viewWithSelect} />

    case gEnums.formItemTypes.gridRowSelect:
    case gEnums.formItemTypes.gridRowSelectFull:
    case gEnums.formItemTypes.menuItemSelect:
    case gEnums.formItemTypes.menuItemSelectFull:
    case gEnums.formItemTypes.menuItemSelectFullCount:
      const { propOptions } = getDynOption(item, localData, view, squares_state)
      return <MenuItemsSelect menuList={propOptions} fip={fip} />

    // case gEnums.formItemTypes.backgroundColorSelectSingle:
    case gEnums.formItemTypes.colorSelect:
    case gEnums.formItemTypes.colorSelectSingle:
      // fip, itemProp
      // return <ThemedColors key={uniqueKey('fi', 'tc')} fip={fip} themeColors={themeColors} itemProp={itemProp} />
      return <ThemedColors key={uniqueKey('fi', 'tc', _key)} formItemType={formItemType} handleChange={handleChange} formKey={formKey} fip={fip} prop={prop} itemProp={itemProp} aaa={_key} cc={localData} item={item} />

    case gEnums.formItemTypes.colorPicker:
      return <ColorPicker key={uniqueKey('fi', _key)} fip={fip} prop={prop} themeColors={localData} />;

    case gEnums.formItemTypes.slider:
      return <NumberPicker fip={fip} itemProp={{}} />

    case gEnums.formItemTypes.listAdd:
    case gEnums.formItemTypes.listView:
      return <ListAdd fip={fip} inverted={true} />

    case gEnums.formItemTypes.itemMap:
    case gEnums.formItemTypes.itemArrayMulti:
      return <ItemMap fip={fip} formItemType={formItemType} themeColors={localData} labelProps={itemProp?.data ? itemProp?.data?.labelProps : null} />

    case gEnums.formItemTypes.appUserDataConstraintList:
    case gEnums.formItemTypes.dataConstraintList:
    case gEnums.formItemTypes.dataMatchConstraintList:
    case gEnums.formItemTypes.imagePropList:
    case gEnums.formItemTypes.pageConstraintList:
      return <DataConstraintList formItemType={formItemType} fip={fip} />

    case gEnums.formItemTypes.numberPicker:
      return <NumberPadPicker fip={fip} itemProp={itemProp} />

    case gEnums.formItemTypes.phoneNumber:
      return <PhoneNumberInput />

    case gEnums.formItemTypes.tableMap:
      const tmProps = { fip, itemProp, data_init, swipedItem, swipeToSelected }
      return <TableMap tmProps={tmProps} />

    case gEnums.formItemTypes.date:
      if (!fip.value && defaultToTodayIfDate) {
        const d = new Date()
        const dd = formatItem(formatTypes.date, d)
        fip.value = dd
      }
      return <DateInput fip={fip} itemProp={itemProp} dateFormat={dateFormat} />

  }
  return (
    <div>FormItemsAlt</div>
  )
}
